function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.375 18H9.187l1.313-7h17.188l-1.313 7z",
  fill: "#19496B"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.427 2.447A3 3 0 0110.376 0H31.27a3 3 0 012.949 3.553l-3.375 18A3 3 0 0127.896 24H7.001a3 3 0 01-2.949-3.553l3.375-18zM8.1 7L5.527 20.724A1.5 1.5 0 007 22.5h20.895a1.5 1.5 0 001.475-1.224L32.048 7H8.1z",
  fill: "#19496B"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 9H0V7h5v2zM0 14h4v-2H0v2zM3 19H0v-2h3v2z",
  fill: "#19496B"
});

var SvgReportingKpiExecuted = function SvgReportingKpiExecuted(props) {
  return React.createElement("svg", _extends({
    width: 35,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgReportingKpiExecuted;